import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=c2a23fca&scoped=true"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=c2a23fca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a23fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2a23fca')) {
      api.createRecord('c2a23fca', component.options)
    } else {
      api.reload('c2a23fca', component.options)
    }
    module.hot.accept("./toolbar.vue?vue&type=template&id=c2a23fca&scoped=true", function () {
      api.rerender('c2a23fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar.vue"
export default component.exports